import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { Product, CloneProductArgs } from '@ztechapps/common.contract'
import { gql } from '@apollo/client'

const defaultQuery = gql`
  mutation cloneProduct($input: CloneProductArgs!) {
    cloneProduct(input: $input) {
      _id
      code
    }
  }
`

export const useCloneProduct = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? defaultQuery

  return useMutation<{ cloneProduct: Product }, CloneProductArgs>({ query, ...props })
}
